<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-label data-cy="sub-menu-label">
      {{ 'i18n.menuProfitPro.pageTitle' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-mobile">
  <div>
    <div
      *ngFor="let item of items; let i = index"
      (click)="select(item)"
      class="click"
    >
      <p class="links">
        {{ item.label | translate }}
      </p>
      <ion-item-divider *ngIf="i < items.length - 1"></ion-item-divider>
    </div>
  </div>
</ion-content>
